import { render } from "./profilemodal.vue?vue&type=template&id=a4a541a6"
import script from "./profilemodal.vue?vue&type=script&lang=js"
export * from "./profilemodal.vue?vue&type=script&lang=js"

import "./profilemodal.vue?vue&type=style&index=0&id=a4a541a6&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__